import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Rating from 'components/rating';
import LazyImage from 'components/lazy-image';

class TestimonialTile extends PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        profile_picture: PropTypes.string.isRequired,
        rating_average: PropTypes.number.isRequired,
        testimonial: PropTypes.string.isRequired,
        rating_count: PropTypes.number.isRequired,
    };

    state = {
        isLoaded: false,
        isVisible: true,
    };

    render() {
        const { name, testimonial, profile_picture, rating_average, rating_count } = this.props;
        const { isVisible } = this.state;

        if (!isVisible) {
            return null;
        }

        return (
            <div className={ 'testimonial-tile' }>
                <div className='testimonial-tile--header'>
                    <div className={ 'testimonial-tile--header-image-wrapper' }>
                        <LazyImage>
                            <img
                                alt={ name }
                                className={ 'testimonial-tile--header-image' }
                                data-src={ profile_picture }/>
                        </LazyImage>
                    </div>

                    <div className={ 'testimonial-tile--header-title' }>
                        { name }
                    </div>

                    <div className={ 'testimonial-tile--header-rating' }>
                        <Rating name={ name } reviews={ rating_average } isEditing={ false } value={ rating_average }/>
                        <span className="testimonial-tile--rating-average">
                            { rating_count }
                        </span>
                    </div>

                </div>
                <div className='testimonial-tile--body'>
                    &laquo;{ testimonial }&raquo;
                </div>
            </div>
        );
    }
}

export default TestimonialTile;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/testimonial-tile/index.js